import { useRouteMatch } from "react-router-dom";
import { supportWidgetPaths } from "@circle-react/helpers/urlHelpers";

interface PostRouteParams {
  id: string;
}

export const useHelpWidgetRoutes = () => {
  const isSpaceGroupsRoutes = Boolean(
    useRouteMatch(supportWidgetPaths.spaceGroups()),
  );

  const postMatch = useRouteMatch<PostRouteParams>("/posts/:id");
  const newsMatch = useRouteMatch<PostRouteParams>("/news/:id");
  const conversationMatch =
    useRouteMatch<PostRouteParams>("/conversations/:id");

  const isSpaceRoute = Boolean(useRouteMatch("/spaces/:spaceId/posts"));
  const isPostRoute = Boolean(postMatch);
  const isNewsRoute = Boolean(newsMatch);
  const isNewsListRoute = Boolean(useRouteMatch("/news"));
  const isEventsRoute = Boolean(useRouteMatch("/events"));
  const isSendUsMessageRoute = Boolean(
    useRouteMatch("/conversations/:id/new_ticket"),
  );
  const isMessageConfirmationRoute = Boolean(
    useRouteMatch("/message_confirmation/:id"),
  );
  const isConversationListRoute = Boolean(useRouteMatch("/conversations"));
  const isConversationRoute = Boolean(conversationMatch);

  const isBackButtonVisible =
    isSpaceRoute ||
    isPostRoute ||
    isNewsRoute ||
    isNewsListRoute ||
    isEventsRoute ||
    isSendUsMessageRoute ||
    isMessageConfirmationRoute ||
    isConversationRoute;

  const isExpandButtonVisible =
    isPostRoute ||
    isNewsRoute ||
    isSendUsMessageRoute ||
    isMessageConfirmationRoute ||
    isConversationRoute;

  const isSpecialHeaderVisible = isBackButtonVisible || isSpaceGroupsRoutes;

  return {
    isSpaceGroupsRoutes,
    isSpaceRoute,
    postMatch,
    newsMatch,
    isPostRoute,
    isNewsRoute,
    isNewsListRoute,
    isEventsRoute,
    isBackButtonVisible,
    isExpandButtonVisible,
    isSpecialHeaderVisible,
    isSendUsMessageRoute,
    isMessageConfirmationRoute,
    isConversationListRoute,
    isConversationRoute,
    conversationMatch,
  };
};
